import React, { forwardRef } from 'react';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Search from '@material-ui/icons/Search';
import ShareIcon from '@material-ui/icons/Share';
import GetAppIcon from '@material-ui/icons/GetApp';
import ViewColumn from '@material-ui/icons/ViewColumn';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';

export const securityType = [
  {
    value: 'UNCLASSIFIED',
    label: 'UNCLASSIFIED',
  },
  {
    value: 'RESTRICTED',
    label: 'RESTRICTED',
  },
  {
    value: 'CONFIDENTIAL',
    label: 'CONFIDENTIAL',
  },
  {
    value: 'SECRET',
    label: 'SECRET',
  },
  {
    value: 'TOP SECRET',
    label: 'TOP SECRET',
  }
];

export const documentType = [
  {
    value: 'Report',
    label: 'Mission Report',
  },
  {
    value: 'Note',
    label: 'Note',
  },
  {
    value: 'Document',
    label: 'Document',
  },
  {
    value: 'Image',
    label: 'Image',
  },
  {
    value: 'Video',
    label: 'Video',
  },
  {
    value: 'Schedule',
    label: 'Flight Schedule',
  },
  {
    value: 'Log',
    label: 'Log',
  },
  {
    value: 'Misc',
    label: 'Other',
  }
];


export const annotationType = [
  {
    value: 'GeoJson',
    label: 'GeoJson',
  }
];


export const tableIcons = {
  AddIcon: forwardRef((props, ref) => <AddIcon {...props} ref={ref} style={{ color: '#90caf9' }} />),
  DeleteIcon: forwardRef((props, ref) => <DeleteIcon {...props} ref={ref} />),
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DeleteSweepIcon: forwardRef((props, ref) => <DeleteSweepIcon {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <FileDownloadIcon {...props} ref={ref} />),
  Import: forwardRef((props, ref) => <FileUploadIcon {...props} ref={ref} />),
  ExportList: forwardRef((props, ref) => <GetAppIcon {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  Share: forwardRef((props, ref) => <ShareIcon {...props} ref={ref} />),
  CloudUploadOutlinedIcon: forwardRef((props, ref) =>
    <div id="open-btn-id" >
        <CloudUploadOutlinedIcon {...props} ref={ref} />
    </div>
 )
};
